export default __webpack_public_path__ + "static/media/build-community.da72ba09.svg";